// video listing utils
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState('user', {
      mainFolders: 'mainFolders',
    }),
  },
  methods: {
    handleRoot() {
      if (this.$route.name != 'Videos') {
        localStorage.removeItem('folderFather')
        this.$router.push({ name: 'Videos' })
      }
    },
    findFolderById(id) {
      return this.mainFolders.find((folder) => {
        return folder.id === id
      })
    },
    checkIfCanOpenVideo(item) {
      if (item.video_external_source_id) return true
      if (!item.created_at || item.status === 'FAILED') return false
      if (
        Math.abs(new Date(item.created_at) - new Date()) / 36e5 > 3 &&
        item.status === 'DRAFT'
      )
        return false
      return true
    },
    handleDoubleClickRow(item) {
      if (item.id === '') return this.handleRoot()
      const canOpen = this.checkIfCanOpenVideo(item)
      if (!canOpen) return
      if (item.live_id) {
        const routeName = 'VideoPage'
        const routeParamId = item.id
        this.$router.push({ name: routeName, params: { id: routeParamId } })
        return
      }
      if (item.name) {
        if (item.id === this.$route.params.id) return

        if (this.$route.name == 'Videos')
          localStorage.setItem('folderFather', item.id)
        this.$router.push({ name: 'Folders', params: { id: item.id } })
      }
      if (item.title) {
        this.handleEditVideo(item)
      }
    },
    handleEditVideo(video) {
      this.UPDATE_ROUTED_VIDEO({ ...video })
      this.$router.push({ name: 'VideoPage', params: { id: video.id } })
    },
  },
}
